<template>
  <div class="pa-login-box-connecting">
    <div class="header">
      <div class="logo">
        <div class="connecting">
          <LoginConnectingTitle class="connecting" />
        </div>
        
        <div class="connected">
          <LoginConnectingConnected class="connecting connected" />
        </div>
      </div>
    </div>

    <div class="indicator">
      <div class="status-column" v-bind:class="indicatorClass.home" ref="indicatorAt_home">
        <LoginStatus1 />
      </div>

      <div class="status-column status-arrow" v-bind:class="arrowClass[0]" ref="arrowAt_0">
        <LoginArrow1 />
      </div>

      <div class="status-column" v-bind:class="indicatorClass.akihabara" ref="indicatorAt_akihabara">
        <LoginStatus2 />
      </div>

      <div class="status-column status-arrow" v-bind:class="arrowClass[1]" ref="arrowAt_1">
        <LoginArrow2 />
      </div>

      <div class="status-column" v-bind:class="indicatorClass.toukei" ref="indicatorAt_toukei">
        <LoginStatus3 />
      </div>

      <div class="status-column status-arrow" v-bind:class="arrowClass[2]" ref="arrowAt_2">
        <LoginArrow3 />
      </div>

      <div class="status-column" v-bind:class="indicatorClass.wotan" ref="indicatorAt_wotan">
        <LoginStatus4 />
      </div>
    </div>

    <div class="infomation">
      <div class="infomation-indicator" v-bind:class="infomationIndicatorClass" ref="infomationIndicator">
        <div class="status-infomation">
          <p class="title">現在の接続先</p>
          <p class="server-state">
            <span class="primary">{{infomation.primary}}</span>
            <span class="secondary">{{infomation.secondary}}</span></p>
          <p class="protocol">{{infomation.protocol}}</p>
          <p class="infomation">{{infomation.infomation}}</p>
        </div>
      </div>

      <div class="infomation-succeeded">
        <div class="connection-success">
          <transition name="text-welcome" v-on:after-enter="textWelcomeShowed">
            <LoginWelcomeText v-if="showConnectionSuccessText['welcome']" class="welcome" />
          </transition>

          <transition name="text-to-masquerade-ball" v-on:after-enter="textMasqueradeShowed">
            <LoginWelcomeText2 v-if="showConnectionSuccessText['masquerade']" class="to" />
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';

import LoginStatus1 from '@/components/FrontParts/LoginModal/LoginBox/Images/status-1.svg?inlineF'
import LoginStatus2 from '@/components/FrontParts/LoginModal/LoginBox/Images/status-2.svg?inlineF'
import LoginStatus3 from '@/components/FrontParts/LoginModal/LoginBox/Images/status-3.svg?inlineF'
import LoginStatus4 from '@/components/FrontParts/LoginModal/LoginBox/Images/status-4.svg?inlineF'

import LoginArrow1 from '@/components/FrontParts/LoginModal/LoginBox/Images/arrow1.svg?inlineF'
import LoginArrow2 from '@/components/FrontParts/LoginModal/LoginBox/Images/arrow2.svg?inlineF'
import LoginArrow3 from '@/components/FrontParts/LoginModal/LoginBox/Images/arrow3.svg?inlineF'

import LoginWelcomeText  from '@/components/FrontParts/LoginModal/LoginBox/Images/welcome_txt.svg?inlineF'
import LoginWelcomeText2 from '@/components/FrontParts/LoginModal/LoginBox/Images/to-masquerade.svg?inlineF'

import LoginConnectingTitle     from '@/components/FrontParts/LoginModal/LoginBox/Images/connecting-title.svg?inlineF'
import LoginConnectingConnected from '@/components/FrontParts/LoginModal/LoginBox/Images/connection-complete-title.svg?inlineF'

export default {
  components : {
    LoginStatus1,
    LoginStatus2,
    LoginStatus3,
    LoginStatus4,
    LoginArrow1,
    LoginArrow2,
    LoginArrow3,

    LoginWelcomeText,
    LoginWelcomeText2,

    LoginConnectingTitle,
    LoginConnectingConnected
  },
  data(){
    return {
      // isInfo?mationSucceeded     : false,
      infomationIndicatorClass  : {
        'infomation-indicator-hide'   : false,
      },
      infomationSucceededClass  : {
        'infomation-succeeded-hide'   : false,
      },
      indicatorClass  : {
        home  : {
          'status-column-connecting'  : false,
          'status-column-connected'   : false,
        },
        akihabara     : {
          'status-column-connecting'  : false,
          'status-column-connected'   : false,
        },
        toukei        : {
          'status-column-connecting'  : false,
          'status-column-connected'   : false,
        },
        wotan        : {
          'status-column-connecting'  : false,
          'status-column-connected'   : false,
        }
      },
      arrowClass      : [
        {
          'status-arrow-connecting-level1'  : false,
          'status-arrow-connecting-level2'  : false,
          'status-arrow-connecting-level3'  : false,
          'status-arrow-connecting-level4'  : false,
          'status-arrow-connected'          : false,
        },
        {
          'status-arrow-connecting-level1'  : false,
          'status-arrow-connecting-level2'  : false,
          'status-arrow-connecting-level3'  : false,
          'status-arrow-connecting-level4'  : false,
          'status-arrow-connected'          : false,
        },
        {
          'status-arrow-connecting-level1'  : false,
          'status-arrow-connecting-level2'  : false,
          'status-arrow-connecting-level3'  : false,
          'status-arrow-connecting-level4'  : false,
          'status-arrow-connected'          : false,
        }
      ],
      statusSet   : [
        {
          primary       : '24区番外地管理局',
          secondary     : '秋葉原駐在所サーバー',
          protocol      : '(HTTPS通信)',
          infomation    : 'HTTPS通信で安全に接続しています。',
        },
        {
          primary       : '24区番外地管理局',
          secondary     : '昭葉原通信交換局',
          protocol      : '(AUETP通信)',
          infomation    : 'AUETP通信で異世界への通信を試みています。',
        },
        {
          primary       : '24区番外地管理局 異世界ヲタン事務所',
          secondary     : '電脳伝心交換機',
          protocol      : '(五四二通信)',
          infomation    : '塔経市帝の異界接続法に基き、魔線接続法第五四二方式にて接続を行っています。',
        }
      ],
      infomation  : {
        primary       : '24区番外地管理局',
        secondary     : '秋葉原駐在所サーバー',
        protocol      : '(HTTPS通信)',
        infomation    : 'HTTPS通信で安全に接続しています。',
      },
      showConnectionSuccessText : {
        'welcome'     : false,
        'masquerade'  : false,
      }
    };
  },
  methods : {
    async textMasqueradeShowed(){
      this.$parent.$parent.$emit('headerIconSpinning');

      await this.UXWaiting(1550);

      this.$router.push({ name: 'home' });
    },

    textWelcomeShowed(){
      this.showConnectionSuccessText.masquerade = true;
    },

    animateArrow(arrowIndex){
      return new Promise((resolve) => {
        this.arrowClass[arrowIndex]['status-arrow-connecting-level1']                 = false;
        this.arrowClass[arrowIndex]['status-arrow-connecting-level2']                 = false;
        this.arrowClass[arrowIndex]['status-arrow-connecting-level3']                 = false;
        this.arrowClass[arrowIndex]['status-arrow-connecting-level4']                 = false;
        this.arrowClass[arrowIndex]['status-arrow-connecting-level'+ _.random(1, 4)]  = true;

        this.$refs['arrowAt_'+arrowIndex].addEventListener('animationend', () => {
          this.arrowClass[arrowIndex]['status-arrow-connected'] = true;

          resolve(this);
        });
      });
    },

    changeStatus(statusName){
      return new Promise((resolve) => {
        this.indicatorClass[statusName]['status-column-connecting'] = true;

        this.$refs['indicatorAt_'+statusName].addEventListener('animationend', () => {
          this.indicatorClass[statusName]['status-column-connected'] = true;

          resolve(this);
        });
      });
    },

    closeInfomationIndicator(){
      return new Promise((resolve) => {
        this.infomationIndicatorClass['infomation-indicator-hide'] = true;

        this.$refs['infomationIndicator'].addEventListener('animationend', () => {
          resolve(this);
        });
      });
    },

    changeMessage(statusNumber){
      this.infomation.primary     = this.statusSet[statusNumber]['primary'];
      this.infomation.secondary   = this.statusSet[statusNumber]['secondary'];
      this.infomation.protocol    = this.statusSet[statusNumber]['protocol'];
      this.infomation.infomation  = this.statusSet[statusNumber]['infomation'];
    },

    async startConnectingAnimation(){
      this.changeMessage(0);
      await this.changeStatus('home');
      await this.animateArrow(0);

      this.changeMessage(1);
      await this.changeStatus('akihabara');
      await this.animateArrow(1);

      this.changeMessage(2);
      await this.changeStatus('toukei');
      await this.animateArrow(2);

      await this.changeStatus('wotan');

      await this.closeInfomationIndicator();

      this.showConnectionSuccessText.welcome = true;
    }
  },

  async mounted(){
    this.startConnectingAnimation();
  }
}
</script>
<style lang="scss">
@import "~bulma/sass/utilities/_all";

@keyframes simpleFadeIn
{
  0%   {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@keyframes scaleFadeIn
{
  0%   {
    transform: scale(.9);
    opacity:0;
  }
  100% {
    transform: scale(1);
    opacity:1;
  }
}

.text-welcome, .text-to-masquerade-ball{
  &-enter-active{
    animation: scaleFadeIn 1.5s normal ease-out;
  }

  &-leave-active{
    animation: scaleFadeIn 1s reverse ease-out;
  }

  &-enter, &-leave-to{
    opacity: 0;
  }
}

div.pa-login-box-connecting{
  .header{
    .logo{

      @include until($tablet) {
        padding:1.6rem 0 0;
      }

      @include from('375px'){
        padding-top:1.9rem;
      }

      @include from('500px'){
        padding-top:3rem;
      }

      @include from($tablet) {
        padding:3rem .5rem .6rem;
      }

      > div{
        text-align: center;

        &.connected{
          display: none;
        }
      }

      img, svg{
        @include until($tablet) {
          width:8rem;
        }

        @include from($tablet) {
          width: 14rem;
        }

        &.connecting{
          @include until($tablet) {
            width:5rem;
          }

          @include from('500px') {
            width: 8rem;
          }
        }
      }
    }
  }

  .indicator{
    width:95%;
    margin:.2rem auto .2rem;
    border-top:3.5px solid #CDB188;
    border-bottom:1px solid #CCBFA5;
    padding:.5rem 0 .5rem;
    display: flex;
    flex-direction: row;

    div.status-column{
      width:14.28%;
      text-align: center;
      opacity: .3;

      img, svg{ vertical-align: middle; }

      @keyframes keyframe-active {
        0% {
          opacity:.3;
        }
        100% {
          opacity:1;
        }
      }

      &-connecting{
        animation: keyframe-active .5s ease-out .5s;
      }

      &-connected{
        opacity: 1 !important;
      }
    }

    div.status-arrow{
      opacity: .3;

      img, svg{
        width:55%;
        vertical-align: middle;
        margin-top:15%;
      }

      @keyframes keyframe-blink {
        0% {opacity:0;}
        50% {opacity:1;}
        100% {opacity:0;}
      }

      &-connecting{
        &-level1{
          animation-name: keyframe-blink;
          animation-duration: .5s;
          animation-iteration-count: 8;
        }

        &-level2{
          animation-name: keyframe-blink;
          animation-duration: .5s;
          animation-iteration-count: 6;
        }

        &-level3{
          animation-name: keyframe-blink;
          animation-duration: .5s;
          animation-iteration-count: 4;
        }

        &-level4{
          animation-name: keyframe-blink;
          animation-duration: .5s;
          animation-iteration-count: 2;
        }
      }

      &-connected{
        opacity: 1 !important;
      }
    }
  }

  .infomation{
    width:95%;
    margin:0 auto;
    position: relative;

    &-indicator{
      p{
        text-align: center;
      }

      p.title{
        color:#73644C;
        margin-top:.4rem;
        margin-bottom:.2rem;
        font-size:.6rem;
        line-height: .6rem;
      }

      p.server-state{
        span{
          display: block;
          font-size:1rem;
          margin-top:.1rem;

          &.primary{
            margin-top:0;
          }

          &.secondary{
            margin-top:0;
            font-size: 1.4rem;
            line-height: 1.5rem;
          }
        }
      }

      p.protocol{
        margin-top:.2rem;
        font-size:.7rem;
        font-weight: bold;
      }

      p.infomation{
        margin-top:.1rem;
        font-size: .8rem;
        line-height: 1.4rem;
        margin-bottom:.4rem;
      }

      &-hide{
        opacity:0;
        animation: simpleFadeIn reverse .5s ease-out;
      }
    }

    &-succeeded{
      position:absolute;
      top:0;
      left:0;
      width:100%;

      img, svg{
        display: block;
        margin:0 auto;

        &.welcome{
          width:6rem;
          margin-top:1.6rem;
          margin-bottom:.8rem;
        }

        &.to{
          width:12rem;
          margin-bottom:1.4rem;
        }
      }
    }
  }
}
</style>
